// vol_* cookie helpers for cross-portal token sharing
const VOL_COOKIE_DOMAIN = '.veilingonline.com.br';
const isParentDomain = location.hostname.includes('veilingonline.com.br');
const domainAttr = isParentDomain ? `; Domain=${VOL_COOKIE_DOMAIN}` : '';

export const setVolCookie = (name: string, value: string, maxAge?: number): void => {
  const secure = location.protocol === 'https:' ? '; Secure' : '';
  const age = maxAge !== undefined ? `; Max-Age=${maxAge}` : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/${domainAttr}; SameSite=Lax${age}${secure}`;
};

export const getVolCookie = (name: string): string => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : '';
};

export const deleteVolCookie = (name: string): void => {
  document.cookie = `${name}=; Path=/${domainAttr}; Max-Age=0`;
};

export const insertInSessionStorageByKey = (key: string, value: string) => {
  localStorage.removeItem(key);

  localStorage.setItem(key, value);
};

export const getSessionStorageValueByKey = (key: string) =>
  localStorage.getItem(key) ?? '';

export const insertInSessionStorageByKeyNotArray = (
  key: string,
  value: string,
) => {
  sessionStorage.removeItem(key);
  sessionStorage.setItem(key, value);
};

export const getSessionStorageValueByKeyNotArray = (key: string) =>
  sessionStorage.getItem(key) ?? '';

export const setLogoutSession = (keys: Array<string>) => {
  keys.forEach((key) => sessionStorage.removeItem(key));
};

export const setLogoutLocal = (keys: Array<string>) => {
  keys.forEach((key) => localStorage.removeItem(key));
};
